import $ from 'jquery';

$(document).ready(function() {
    $('.js-game-puzzle-play').on('click', function() {
        $('.b-game-puzzle').addClass('start');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-puzzle/game-puzzle.js